@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <div class="title-start">
            <strong>{{ 'steps.update-success.start' | translate }}</strong>
            <p [innerHTML]="'steps.update-success.start_subtitle' | translate"></p>
        </div>
    </form>
}
